import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '../Buttons/ButtonBase';
import { FieldArray } from 'formik';
import  LawyerNewContactsForm from './LawyerNewContactsForm';
import "./addNewContacts.scss";

const styles = () => ({
  expandButton: {
    display: 'flex',
    color: '#013957',
    cursor: 'pointer',
  },
  ButtonBase: {
    padding: 0,
    margin: 0,
    width: 144,
    minWidth: 'initial',
  },
  linkStyle: {
    width: 144,
    margin: '0 10px 0 0',
    '&:last-child': {
      margin: 0
    }
  },
});

const NewContactFormContainer = props => {

    const {
      values,
      handleChange,
      handleBlur,
      handleSubmit,
      touched,
      errors,
      classes,
      setFieldValue,
      isValid,
      evento,
      helper,
      helperTrue,
      helperFalse,
      getValues,
      resetForm
    } = props; 
    
    const isObjectFull = (array) => {
      if (array && array.length !== 0) {
        const allValues = Object.values(array.slice(-1).pop())
        const evaluation = allValues.every(elem => {
          if (elem !== '') {
            return true
          }
          return false
        })
        return evaluation;
      }
    }

    const handleCancel = event => {
      event.preventDefault();
      resetForm()
      evento();
    };

    useEffect(() => {
      getValues(isObjectFull(values.newContacts))
      if (helper && isObjectFull(values.newContacts)) {
        values.newContacts.push({
          names: '',
          lastName: '',
          phone: '',
          typePhone: '',
          email: '',
          source: 'Contacta Abogado®',

        })
      }
      helperFalse()
    }, [
      getValues,
      helper,
      helperFalse,
      helperTrue,
      values.newContacts
    ])
    
  return (
    <>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name='newContactsLawyer'
          render={newContactsHelper => {
            return (
              <>
                {values.newContacts && values.newContacts.map((newContact, index) => (
                    <LawyerNewContactsForm
                      index={index}
                      key={index}
                      newContact={newContact}
                      newContactsHelper={newContactsHelper}
                      errors={errors}
                      touched={touched}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      handleCancel={handleCancel}
                      setFieldValue={setFieldValue}
                      isValid={isValid}
                    />
                  ))
                }
              </>
            )}
          }
        />

        {/* <div className="addNewContacts_horizontal-layoutNewContact" style={{ marginTop: 15 }}>
          <div style={{ display: 'flex' }}>
            <ButtonBase
              type="submit"
              onClick={handleSubmit}
              variant="primary"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase }
              style={{ marginRight: 16}}
            >
              Guardar
            </ButtonBase>

            <ButtonBase
              type="submit"
              onClick={handleCancel}
              variant="primarySolidOutlined"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase}
            >
              Cancelar
            </ButtonBase>
          </div>
        </div> */}
      </form>
    </>
  )
};

export default withStyles(styles)(NewContactFormContainer);
